import * as React from "react"
import Svg, {
  SvgProps,
  Defs,
  LinearGradient,
  Stop,
  Path,
  G,
  Circle,
} from "react-native-svg"

const SvgComponent = (props) => (
  <Svg
    id="uuid-421edda3-6cb3-4f80-933c-7870c5c27489"
    xmlns="http://www.w3.org/2000/svg"
    width={469}
    height={134}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 4691.96 1344.17"
    {...props}
  >
    <Defs>
      <LinearGradient
        id="uuid-bd9539ae-d7ab-4d6c-9132-1411f79ace7d"
        x1={139.69}
        y1={1095.57}
        x2={1154.2}
        y2={492.95}
        gradientTransform="translate(4.26 1354.45) rotate(-.27) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#fff" stopOpacity={0} />
        <Stop offset={0.88} stopColor="#494949" stopOpacity={0.21} />
        <Stop offset={1} stopColor="#000" stopOpacity={0.3} />
      </LinearGradient>
      <LinearGradient
        id="uuid-d4a241a1-43e9-4e6c-bb9c-41f5afafaedf"
        x1={787.75}
        y1={637.75}
        x2={-101.25}
        y2={1230.42}
        gradientTransform="translate(-20.69 1331.59) rotate(.71) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#fff" stopOpacity={0} />
        <Stop offset={0.13} stopColor="#aeaeae" stopOpacity={0.09} />
        <Stop offset={1} stopColor="#000" stopOpacity={0.3} />
      </LinearGradient>
      <LinearGradient
        id="uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b"
        x1={1267.86}
        y1={268.92}
        x2={1344.41}
        y2={268.92}
        gradientTransform="translate(510.98 -780.61) rotate(94.19) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#2c6b35" />
        <Stop offset={1} stopColor="#92c144" />
      </LinearGradient>
      <LinearGradient
        id="uuid-049669ea-3bef-4857-86e7-123332141446"
        x1={1313.42}
        y1={312.92}
        x2={1383.2}
        y2={312.92}
        xlinkHref="#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b"
      />
      <LinearGradient
        id="uuid-46ec9d05-ddf6-451c-95ec-ef6be77b9aab"
        x1={1313.42}
        y1={312.92}
        x2={1383.2}
        xlinkHref="#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b"
      />
      <LinearGradient
        id="uuid-05c8197e-c088-4efb-90b4-6877a500d86a"
        x1={1414.9}
        y1={392.32}
        x2={1490.2}
        y2={392.32}
        xlinkHref="#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b"
      />
      <LinearGradient
        id="uuid-efdff83d-9c2d-45de-ab1e-d381a04930c2"
        x1={1472.57}
        y1={309.68}
        x2={1496.61}
        y2={469.04}
        gradientTransform="translate(510.98 -780.61) rotate(94.19) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#92c144" />
        <Stop offset={1} stopColor="#2c6b35" />
      </LinearGradient>
      <LinearGradient
        id="uuid-c7073f08-fa9c-46cc-84f9-1a26527c74fe"
        x1={1379.5}
        y1={314.63}
        x2={1542.17}
        y2={314.63}
        xlinkHref="#uuid-efdff83d-9c2d-45de-ab1e-d381a04930c2"
      />
      <LinearGradient
        id="uuid-f41e9200-8cb7-49de-8e7c-86cbae0f4647"
        x1={600.4}
        y1={225.73}
        x2={800.7}
        y2={225.73}
        xlinkHref="#uuid-efdff83d-9c2d-45de-ab1e-d381a04930c2"
      />
      <LinearGradient
        id="uuid-e3e0708b-0768-41a7-9ac2-fe6b9708fef4"
        x1={1280.4}
        y1={175.22}
        x2={1443.2}
        y2={175.22}
        xlinkHref="#uuid-efdff83d-9c2d-45de-ab1e-d381a04930c2"
      />
      <LinearGradient
        id="uuid-33e15609-3bf4-4f79-8444-248795ec445c"
        x1={1467.62}
        y1={501.66}
        x2={1257.43}
        y2={156.16}
        gradientTransform="translate(510.98 -780.61) rotate(94.19) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#fff" />
        <Stop offset={1} stopColor="#7bc8cd" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="uuid-b809095f-05b8-43c8-8ac0-2915d4457851"
        x1={1279.9}
        y1={321.37}
        x2={1541.58}
        y2={321.37}
        gradientTransform="translate(510.98 -780.61) rotate(94.19) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#19598c" />
        <Stop offset={1} stopColor="#19598c" stopOpacity={0} />
      </LinearGradient>
      <LinearGradient
        id="uuid-0f91d19b-0245-4e46-ad6a-1c007cb8aa00"
        x1={1280.2}
        y1={322.32}
        x2={1491.5}
        y2={322.32}
        gradientTransform="translate(510.98 -780.61) rotate(94.19) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#2c6b35" />
        <Stop offset={0.5} stopColor="#92c144" />
        <Stop offset={1} stopColor="#2c6b35" />
      </LinearGradient>
      <LinearGradient
        id="uuid-4445a5df-eb30-4f3f-9d1a-68f323b59229"
        x1={1280.1}
        y1={154.12}
        x2={1350.1}
        y2={154.12}
        xlinkHref="#uuid-0f91d19b-0245-4e46-ad6a-1c007cb8aa00"
      />
      <LinearGradient
        id="uuid-af94f313-1bd8-4426-9824-885f86511006"
        x1={1267.95}
        y1={317.77}
        x2={1490.3}
        y2={317.77}
        xlinkHref="#uuid-0f91d19b-0245-4e46-ad6a-1c007cb8aa00"
      />
      <LinearGradient
        id="uuid-ee410204-9dbb-4449-90fc-c42a3e0b1cde"
        x1={824.12}
        y1={726.63}
        x2={806.46}
        y2={697.59}
        gradientTransform="translate(-59.07 74.93) rotate(-5.64)"
        xlinkHref="#uuid-33e15609-3bf4-4f79-8444-248795ec445c"
      />
      <LinearGradient
        id="uuid-c579858c-bb2f-4ab6-8159-6019afc754bb"
        x1={809.03}
        y1={685.28}
        x2={791.36}
        y2={656.24}
        gradientTransform="translate(-59.07 74.93) rotate(-5.64)"
        xlinkHref="#uuid-33e15609-3bf4-4f79-8444-248795ec445c"
      />
    </Defs>
    <Path
      d="m755.9,560.35c119.84,70.94,154.58,137.73,137.2,198.9-.02.08-.05.16-.07.24.09,3.91-.66,7.68-2.07,11.17-.15,1.99-.36,3.98-.65,5.95,28.09-10.49,66.18-28.1,92.46-40.13,21.52-9.85,33.62-18.61,46.55-31.68-217.72-115.74-273.42-144.46-273.42-144.46h0Z"
      style={{
        fill: "url(#uuid-bd9539ae-d7ab-4d6c-9132-1411f79ace7d)",
      }}
    />
    <Path
      d="m580.98,585.36c-12.63-26.52-16.97-56.49-8.36-84.9.4-1.33.86-2.68,1.35-4.04-4.12-4.5-7.03-10.16-8.33-16.38-2.83-.06-5.65-.09-8.48-.07-54.64.36-104.33,16.3-148.41,49.82-.8.61-1.61,1.22-2.41,1.83,54.87,32.36,109.77,64.69,164.7,96.95,31.55,18.53,63.12,37.03,94.72,55.49,13.64,7.97,27.23,16.24,41.03,23.82-48.99-30.63-100.29-68.97-125.82-122.54v.02Z"
      style={{
        fill: "url(#uuid-d4a241a1-43e9-4e6c-bb9c-41f5afafaedf)",
      }}
    />
    <G>
      <Path
        d="m1894.8,796.66c0-19.24.1-38.48-.04-57.72-.08-11.14.19-22.26,1.1-33.34,1.26-15.31,4.3-30.23,10.23-44.35,12.05-28.69,32.85-46.91,60.84-56.37,16.74-5.66,33.99-6.56,51.41-5.77,17.96.81,35.14,5.01,51.49,12.93,14.78,7.15,27.59,17.11,37.96,30.4,4.32,5.54,8.68,11.09,12.57,16.96,4.82,7.27,8.61,5.6,12.65-.2,4.92-7.08,10.28-13.87,15.9-20.36,17.18-19.85,38.75-31.39,63.5-36.82,15.83-3.47,31.81-3.81,47.82-2.51,12.06.98,23.84,3.8,35.06,8.77,28.71,12.71,47.53,34.9,56.55,66.33,3.12,10.89,4.84,22.07,5.74,33.43.86,10.88.88,21.76.88,32.65v143.26c0,2.31.07,4.65-.21,6.94-.32,2.61-1.88,3.95-4.47,4.2-1.31.12-2.63.1-3.95.1h-32.25c-1.32,0-2.64.03-3.95-.09-3.18-.29-4.35-1.39-4.63-4.67-.21-2.53-.16-5.09-.16-7.64,0-50.3.03-100.61-.03-150.91-.02-12.79-1.29-25.44-4.91-37.73-1.97-6.67-4.6-13.03-8.24-18.87-9.31-14.91-22.56-23.85-38.88-27.49-16.11-3.59-32.33-3.31-48.18,1.63-25.69,8.01-42.46,26-51.01,52.62-3.47,10.81-5.05,22.04-5.53,33.43-.19,4.4-.16,8.81-.16,13.21-.01,46.13.04,92.26-.04,138.4-.02,10.82,1.12,7.36-5.57,15.28-3.21,3.8-6.53,7.51-9.8,11.26-.89,1.02-1.74,2.1-2.69,3.05-4.49,4.49-9.54,4.56-14.05.23-.32-.31-.62-.65-.92-.99-5.05-5.8-10.06-11.64-15.17-17.38-1.6-1.8-2.51-3.7-2.37-6.2.11-1.85.01-3.71.01-5.56,0-48.22-.03-96.44.02-144.66.01-13.31-1.41-26.39-5.36-39.03-9.83-31.47-30.23-50.27-61.17-55.95-13.75-2.52-27.51-2.31-41.1,1.43-19.79,5.45-33.67,18.2-41.71,38.05-3.57,8.81-5.62,18.07-6.5,27.54-.73,7.83-1.06,15.73-1.08,23.6-.09,48.68-.04,97.36-.06,146.05,0,2.55-.02,5.1-.27,7.63-.21,2.18-1.37,3.24-3.44,3.56-1.08.16-2.19.19-3.28.19-11.85.01-23.7.06-35.54-.02-5.76-.04-6.78-1.21-6.97-7.38-.05-1.62-.01-3.25-.01-4.87v-86.24h-.03Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m3073.36,644.45h-20.21c-6.57,0-13.6.04-20.4-.01-6.55-.05-13.1.23-19.96-.23-.33-1.55-.83-2.84-.83-4.14-.06-12.29-.04-24.57,0-36.86,0-1.11.34-2.21.53-3.37,2.46-1.35,4.9-.96,7.26-.97,15.36-.04,30.71,0,46.07-.03,2.6,0,5.2-.17,7.98-.26.48-1.66,1.03-2.91,1.17-4.22.2-1.83.11-3.7.11-5.56v-180.81c0-7.43-.49-14.8-2.17-22.06-3.78-16.3-15.14-30.64-37.44-32.05-10.2-.65-20.12.85-29.63,4.96-2.86,1.24-5.81,2.17-8.96,1.52-5.29-1.1-9.3-4.07-11.53-9.33-2.87-6.75-5.6-13.56-8.5-20.61,1.17-1.21,2.12-2.46,3.3-3.37,8.44-6.52,17.91-10.64,27.99-13.38,19.07-5.19,38.28-5.57,57.31-.59,31.41,8.22,50.3,29.56,56.78,63.05,1.81,9.34,2.37,18.83,2.37,28.34.04,61.43.02,122.86.03,184.29,0,2.99-.2,6,.33,8.66,2.75,2,5.47,1.4,8.04,1.41,15.8.06,31.59.02,47.39.04,2.37,0,4.79-.28,7.4.85,1.11,7.36.41,14.75.52,22.09.11,7.16-.03,14.33-.06,21.15-2.3,2.13-4.59,1.46-6.7,1.46-16.45.06-32.91.02-49.36.04-2.39,0-4.78.12-7.39.18-.4,1.61-.89,2.88-1.01,4.19-.17,1.84-.07,3.7-.07,5.56,0,123.09,0,246.18-.02,369.27,0,7.23.62,14.34,2.5,21.3,4.91,18.14,18.12,29.23,35.95,30.26,10.63.62,21.01-.43,30.98-4.75,4.23-1.84,8.54-1.81,12.78.17,3.12,1.46,5.65,3.77,7.06,6.99,2.93,6.72,5.58,13.58,8.31,20.4.15.39.02.9.02,1.58-1.5,2.18-3.8,3.56-5.99,5.05-8.78,5.96-18.41,9.7-28.58,11.95-19.42,4.3-38.82,4.3-57.91-1.69-28.46-8.92-45.48-29.3-51.94-59.69-1.93-9.06-2.66-18.29-2.65-27.6.04-124.25.03-248.5,0-372.75,0-3.18.37-6.43-.85-10.46l-.02.03Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m3555.79,521.04c-3.42,8.64-6.25,16.92-9.92,24.76-5.07,10.83-16.95,13.58-25.93,9.47-7.64-3.49-15.23-7.17-23.07-10.08-22.76-8.42-46.23-12.65-70.39-11.67-13.82.56-27.54,2.17-40.81,6.69-11.02,3.75-20.99,9.4-29.24,18.09-13.86,14.62-18.39,32.19-14.31,52.27,1.75,8.63,6.07,15.82,12.2,21.79,8.17,7.94,17.53,13.87,27.84,18.13,11.45,4.73,23.28,8.17,35.17,11.4,18.67,5.07,37.39,9.96,56.02,15.21,12.07,3.4,23.91,7.63,35.53,12.54,15.08,6.38,28.22,15.78,39.72,27.89,10.56,11.12,17.56,24.23,20.55,39.64,3.63,18.67,3.63,37.28-1.55,55.68-6.71,23.83-20.12,42.46-39.63,56.24-16.65,11.76-35.03,18.91-54.58,23.09-22.98,4.91-46.23,5.49-69.45,3.77-32.45-2.4-63.5-11.05-92.73-26.4-9.26-4.86-18-10.61-26.06-17.47-2.02-1.72-4.25-3.25-5.79-6.17,3.27-7.18,6.26-14.65,9.97-21.69,4.6-8.74,15.74-13.25,25.81-8.17,1.77.9,3.45,2.02,5.15,3.07,24.18,14.87,50.16,24.09,77.91,27.98,15.75,2.21,31.52,2.2,47.27.89,13.14-1.09,26.06-3.74,38.27-9.34,7.93-3.64,15.14-8.43,21.17-15.01,13.56-14.79,17.13-32.41,12.51-52.02-2.01-8.53-6.74-15.49-12.99-21.31-8.85-8.23-18.88-14.36-30.08-18.11-11.9-3.99-23.9-7.67-35.95-11.11-18.4-5.25-36.96-9.89-55.3-15.34-10.74-3.19-21.31-7.14-31.75-11.31-15.19-6.07-28.28-15.63-39.74-27.8-10.5-11.15-17.5-24.24-20.61-39.62-3.81-18.88-3.9-37.75,1.06-56.41,6.22-23.43,19.08-41.98,37.92-55.92,16.22-12.01,34.17-19.79,53.51-23.95,22.25-4.79,44.71-6.13,67.4-4.47,22.89,1.68,45.17,6.25,66.8,14.29,11.2,4.17,21.9,9.49,31.99,16.14,1.85,1.22,3.63,2.54,6.15,4.32l-.04.02Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m1545.33,846.52c3.43-7.57,6.3-14.6,9.72-21.31,5.38-10.57,17.04-14.19,27.17-8.8.98.52,1.91,1.13,2.85,1.73,23.2,14.82,48.33,24.12,75.04,28.36,22.92,3.64,45.89,3.42,68.75-1.09,7.56-1.49,14.9-3.83,21.95-7.11,8.33-3.88,15.73-9.2,21.87-16.34,7.97-9.26,12.41-20.13,12.66-32.7.09-4.38.03-8.85-.67-13.15-1.52-9.39-5.67-17.43-12.26-24.05-9.06-9.11-19.59-15.69-31.42-19.7-12.09-4.11-24.3-7.87-36.58-11.29-19.91-5.53-40.09-10.06-59.71-16.73-10.01-3.4-19.97-7-29.74-11.09-14.26-5.97-26.47-15.3-37.28-26.78-10.66-11.33-17.58-24.72-20.63-40.37-3.55-18.21-3.63-36.4.96-54.38,6.51-25.52,20.79-45.14,41.67-59.51,17.35-11.94,36.41-19.16,56.73-22.87,15.39-2.81,30.91-4.12,46.5-3.76,33.41.77,65.84,6.82,96.4,21.76,6.15,3.01,11.98,6.76,17.91,10.26,1.5.88,2.8,2.14,4.36,3.36-.41,1.48-.67,2.82-1.15,4.06-2.47,6.44-4.81,12.94-7.53,19.26-4.01,9.28-11.89,13.91-21.34,12.51-2.75-.41-5.48-1.62-8.03-2.89-13.95-6.93-28.41-12.18-43.48-15.6-18.54-4.22-37.2-5.99-56.19-4.14-10.74,1.04-21.32,2.62-31.63,6-12.16,3.98-22.98,10.38-31.6,20.43-12.61,14.7-16.39,31.88-12.07,51.01,1.93,8.56,6.49,15.63,12.72,21.48,9.15,8.58,19.61,14.75,31.11,19.02,15.32,5.69,31.01,9.97,46.8,13.9,23.26,5.8,46.34,12.22,68.86,20.76,14.59,5.53,28.08,13.05,39.77,23.91,2.96,2.75,5.8,5.66,8.57,8.63,9.28,10,15.45,21.85,18.45,35.48,4.25,19.3,4.39,38.62-.89,57.71-6.18,22.33-18.33,40.35-36.2,54-15.69,11.98-33.21,19.68-51.98,24.26-14.35,3.5-28.9,5.57-43.64,5.68-9.65.07-19.33.38-28.95-.28-35.65-2.46-69.57-11.82-101.21-29.66-7.17-4.05-13.93-8.8-20.28-14.17-2.04-1.72-3.96-3.6-6.37-5.8h0Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m4678.48,520.55c-3.19,8.12-6.15,15.58-9.05,23.08-3.7,9.59-15.59,16.5-26.99,10.75-9.9-4.99-20.08-9.27-30.58-12.67-23.78-7.72-48.11-10.2-72.82-8.23-12.48,1-24.78,3.33-36.51,8.29-9.93,4.21-18.73,10.17-25.85,18.64-12.14,14.43-15.54,31.25-11.68,49.87,1.85,8.91,6.52,16.1,12.88,22.13,8.6,8.16,18.48,14.06,29.27,18.29,11.52,4.52,23.36,7.94,35.25,11.14,17.2,4.63,34.49,8.91,51.57,13.97,12.22,3.62,24.29,7.94,36.2,12.58,16.95,6.6,31.45,17.27,43.74,31.27,5.26,5.99,9.55,12.65,12.82,20.08,3.47,7.91,5.38,16.07,5.22,24.85-.2,11.12-.14,22.25,0,33.38.09,7.54-1.33,14.65-3.91,21.67-8.37,22.72-22.82,39.82-42.47,52.26-16.38,10.36-34.13,16.74-52.86,20.24-17.12,3.2-34.39,4.51-51.75,3.94-39.8-1.3-77.7-10.58-112.97-30.6-7.36-4.18-14.26-9.11-20.74-14.69-1.68-1.44-3.22-3.06-4.93-4.71.5-1.57.78-2.91,1.32-4.11,2.51-5.66,4.92-11.39,7.67-16.92,4.27-8.57,11.66-12.57,20.68-11.58,3.36.37,6.29,1.86,9.12,3.69,14.86,9.63,30.78,16.7,47.44,22,23.77,7.56,48.1,10.29,72.82,8.72,13.81-.87,27.48-2.9,40.58-8,8.95-3.48,17.18-8.26,24.09-15.26,14.63-14.81,19.02-32.81,14.26-53.37-1.81-7.82-5.87-14.41-11.41-19.97-8.73-8.75-18.92-14.97-30.2-19.23-16.54-6.24-33.53-10.79-50.57-15.13-23.23-5.92-46.31-12.35-68.8-20.99-16.95-6.51-31.9-16.2-44.69-29.77-10.52-11.16-17.67-24.16-20.78-39.52-3.91-19.33-4-38.67,1.27-57.76,7.09-25.65,22.07-44.95,43.41-58.96,15.65-10.28,32.64-16.81,50.65-20.58,21.02-4.4,42.27-5.24,63.55-3.9,26.19,1.65,51.67,7.25,76.05,17.8,8.74,3.79,17.14,8.3,25.1,13.69,1.45.98,2.79,2.16,4.61,3.59v.03Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m4344.28,885.23c-6.22,5.07-12.98,8.35-20.43,9.46-9.42,1.4-18.81.79-27.93-2.55-18.61-6.82-30.08-20.9-31.69-44.04-.14-2.06-.16-4.13-.26-6.84-1.34.62-2.43.82-3.07,1.49-2.49,2.61-4.78,5.43-7.25,8.06-22.04,23.55-48.67,37.85-79.62,42.31-76.54,11.04-142.75-43.6-156.05-117.13-8.99-49.67,4.32-92.58,36.68-129.13,18.53-20.93,41.02-35.29,67.4-42.61,12.85-3.56,25.89-4.56,39.11-3.97,31.11,1.4,58.52,12.93,82.54,33.67,6.81,5.88,12.93,12.52,18.56,19.67,1.08,1.38,2.29,2.65,3.32,3.84,1.84-.52,1.58-1.84,1.64-2.9.79-15.04,1.53-30.08,2.32-45.11.14-2.74-.2-5.58,1.3-8.45,1.14-.23,2.38-.68,3.63-.69,8.34-.07,16.67-.05,25.01-.04.88,0,1.76.03,2.62.18,2.25.37,3.51,1.74,3.62,4.18.09,1.84-.04,3.71-.14,5.55-.68,12.02-1.58,24.04-2.04,36.07-.75,19.45-1.31,38.91-1.8,58.36-.57,22.47-.99,44.94-1.46,67.41-.27,13.2-.54,26.41-.76,39.61-.12,6.99.63,13.89,2.56,20.59,1.48,5.14,3.73,9.9,7.02,14.04,5.09,6.41,11.29,9.95,19.55,9.09,7.05-.74,8.3.4,10.26,7.57,1.52,5.56,3,11.13,4.42,16.72.44,1.74.61,3.56.93,5.56v.03Zm-189.26-32.09c6.54-.09,14.15-.84,21.64-2.82,38.38-10.11,70.48-45.99,74.23-93.17,2.33-29.26-5.89-55.45-24.11-77.75-26.21-32.09-67.67-43.54-104.52-28.88-45.96,18.29-75.02,72.07-60.43,127.23,10.92,41.3,46.67,74.97,93.19,75.38h0Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m3876.42,841.33c-2.32.96-3.45,3.02-4.87,4.66-11.81,13.66-25.46,24.76-41.16,33.02-15.88,8.35-32.61,13.31-50.32,14.88-32.21,2.86-61.95-4.85-88.76-23.75-32.99-23.27-53.38-55.73-60.39-97.09-7.52-44.29,3.47-83.6,30.3-118.03,19.64-25.2,44.4-42.43,74.45-50.82,12.84-3.58,25.9-4.51,39.12-3.93,25.15,1.1,48.17,9.11,69.27,23.48,11.7,7.97,21.95,17.68,30.92,28.93,1.26,1.58,2.62,3.07,3.96,4.58.12.14.42.11.65.16,1.71-.58,1.33-2.17,1.39-3.46.57-13.19,1.05-26.39,1.67-39.58.2-4.36.72-8.71,1.11-13.23,1.67-.35,2.92-.82,4.17-.83,8.33-.07,16.67-.05,25.01-.05.44,0,.88,0,1.31.05,3.7.33,4.8,1.35,4.75,5.12-.06,5.1-.36,10.19-.61,15.28-.26,5.32-.65,10.63-.87,15.96-.73,18.05-1.4,36.11-2.1,54.17-.03.69-.1,1.39-.12,2.08-.96,41-2.22,82-1.99,123.03.04,7.53,1.26,14.74,4.15,21.62,1.71,4.06,3.96,7.73,6.96,10.88,4.76,5,10.32,7.74,17.17,6.92.22-.03.44-.05.66-.06,6.8-.39,8.1.44,9.96,7.12,2.03,7.3,3.88,14.66,5.89,22.27-1.55,1.26-2.84,2.48-4.28,3.44-18.67,12.48-46.41,7.71-61.02-5.7-7.77-7.13-12.42-16.09-14.12-26.74-.65-4.1-.88-8.27-1.37-12.39-.07-.59-.49-1.13-.88-1.97v-.02Zm-11.68-93.26c-.3-4.42-.33-9.32-1.01-14.12-3.45-24.15-13.05-45.19-30.15-61.76-26.21-25.4-56.87-34.13-91.31-23.82-47.47,14.2-76.58,65.59-69.98,114.07,3.34,24.54,12.88,45.68,29.95,62.57,24.62,24.38,53.9,33.35,86.82,25.46,42.24-10.13,75.31-51.44,75.67-102.4h.01Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m2667.16,657.89c.99-19.23,1.95-37.69,2.92-56.4,1.5-.46,2.7-1.12,3.9-1.14,8.77-.1,17.55-.15,26.32-.03,4.49.06,5.89,1.8,5.56,6.47-2.13,30.51-3.16,61.08-3.86,91.66-.44,19-.98,37.99-1.35,56.99-.38,19.92-.63,39.85-.9,59.78-.1,7.51,1.28,14.75,4.02,21.67,1.97,4.98,4.78,9.38,8.66,12.95,4.31,3.97,9.25,6.13,15.07,5.59.66-.06,1.31-.16,1.96-.2,5.82-.32,7.62.79,9.21,6.47,2.11,7.52,3.97,15.12,5.99,22.9-1.35,1.19-2.38,2.38-3.65,3.17-7.28,4.56-15.01,7.4-23.63,7.54-9.59.16-18.76-1.38-27.46-5.77-14.65-7.4-22.85-19.71-25.09-36.57-.37-2.75-.35-5.55-.62-8.31-.1-1.05-.49-2.08-.74-3.12-2.68.36-3.56,2.43-4.82,3.89-7.4,8.62-15.56,16.32-24.62,22.95-18.17,13.29-38.22,21.71-60.09,24.8-75.87,10.72-141.6-42.75-155.51-115.33-10.25-53.49,5.03-98.83,41.54-136.54,17.58-18.15,38.45-30.56,62.34-37.12,12.85-3.53,25.9-4.49,39.13-3.91,24.68,1.07,47.34,8.83,68.16,22.74,12.14,8.11,22.76,18.09,32.03,29.69,1.36,1.71,2.33,3.91,5.53,5.17h0Zm-209.16,92.26c.25,3.65.3,8.55.98,13.34,3.49,24.41,13.27,45.6,30.6,62.25,26.15,25.12,56.82,33.7,90.86,23.37,49.54-15.04,75.9-67.34,70.14-112.71-2.77-21.79-10.24-41.25-24.21-57.45-24.5-28.4-55-40.08-90.8-32.4-43.82,9.4-77.35,51.97-77.58,103.6h.01Z"
        style={{
          fill: "#686868",
        }}
      />
      <Path
        d="m2848.43,895.89c-5.74,7.2-11.28,14.38-17.07,21.34-3.69,4.43-8.25,4.5-11.87.2-5.24-6.23-10.19-12.73-15.33-19.06-1.57-1.93-1.76-4.13-1.76-6.49,0-21.08.02-42.16-.08-63.24-.11-25.02-.63-50.03-.42-75.05.19-23.25,3.13-46.15,10.29-68.3,9.83-30.41,27.64-53.86,54.2-69.79,11.99-7.19,24.79-11.73,38.48-13.12,12.87-1.31,25.77-2.19,38.66-3.2,2.16-.17,4.35-.02,6.76-.02.34,1.34.83,2.41.84,3.47.04,14.36.02,28.73,0,43.09,0,.67-.24,1.34-.35,1.93-1.46,1.71-3.31,1.17-5,1.15-6.58-.07-13.12.16-19.68.98-34.94,4.37-62.44,27.2-72.42,65.89-3.19,12.36-4.76,24.98-5.12,37.72-.36,12.73-.2,25.48-.2,38.22,0,33.13.04,66.26.07,99.39v4.89h0Z"
        style={{
          fill: "#686868",
        }}
      />
    </G>
    <Path
      d="m1391.69,622.86c.12,52.64.19,105.28-.17,157.91-.25,37.35-.72,74.7-1.55,112.04-.76,34.27,3.24,71.18-13.61,102.23-8.75,16.13-22.09,29.12-37.6,38.77-7.45,4.64-15.52,8.05-23.27,12.09-45.18,23.51-90.3,47.15-135.44,70.73-19.91,10.4-39.86,20.73-59.78,31.13-46.52,24.28-93.03,48.59-139.54,72.89-29.64,15.48-59.28,30.96-88.92,46.46-39.36,20.58-78.68,41.23-118.11,61.69-10.71,5.56-22.34,8.73-34.1,11.17-14.81,3.08-29.82,4.68-44.95,4.08-27.38-1.09-53.58-6.87-78.03-19.79-33.97-17.94-68.09-35.58-102.13-53.38-36.93-19.31-73.84-38.65-110.76-57.97-35.25-18.45-70.5-36.9-105.75-55.35-44.82-23.46-89.65-46.91-134.47-70.36-29.94-15.66-59.89-31.29-89.82-46.94-12.21-6.38-23.69-13.84-33.83-23.22-18.09-16.73-29.12-37.43-34.58-61.29-3.11-13.57-4.69-27.34-5.11-41.22-.33-10.91-.07-21.84-.07-32.89,1.15-.31,1.75.99,2.53,1.77,32.65,32.35,69.88,58.47,109.92,80.79,31.79,17.72,64.73,33.07,97.91,47.95,26.13,11.71,52.23,23.47,78.64,34.53,27.19,11.39,54.43,22.67,81.67,33.95,35.16,14.56,70.27,29.22,105.51,43.58,25.55,10.41,51.25,20.47,76.93,30.58,21.69,8.55,43.05,17.89,64.58,26.82,16.01,6.64,32.35,12.22,49.4,15.69,28.06,5.71,54.99,3.05,81.42-8.41,35.85-15.54,72.09-30.21,108.16-45.25,41.13-17.15,82.27-34.31,123.4-51.45,35.44-14.77,70.9-29.51,106.34-44.27,40.04-16.67,80.16-33.14,120.07-50.09,27.73-11.77,44.01-33.47,51.6-62.15,3.39-12.82,4.66-25.95,5.03-39.14.46-16.29-.73-32.53-1.69-48.79-1.12-19-1.39-38.03-1.35-57.07.1-49.91.16-99.82.22-149.74,0-3.94.03-7.85-1-11.74-1.45-5.48-4.63-9.46-9.53-12.17-3.33-1.84-6.95-2.91-10.55-4.03-36.31-11.32-72.63-22.65-108.95-33.95-64.95-20.21-129.91-40.4-194.87-60.59-45.16-14.04-90.52-27.35-136.35-39.06-31.53-8.05-63.2-15.57-95.3-20.97-18.43-3.1-37.04-5-55.78-4.29-21.96.84-43.22,4.83-63.06,14.78-1.87.94-3.69,1.65-5.88,1.34-11.4-1.63-22.87-1.98-34.37-1.77-50.57.94-96.38,15.87-136.79,46.6-2.59,1.97-5.17,3.96-7.78,5.92-2.79,2.1-2.73,2.02-5.24-.68-5.76-6.18-7.22-13.86-7.58-21.84-.24-5.31-.06-10.63-.06-15.95.01-31.9.07-63.81,0-95.71-.01-5.16.33-10.28.99-15.37,1.05-8.13,5.46-14.31,11.93-19.08,8.43-6.22,17.6-11.3,26.49-16.8,38.78-24.01,77.62-47.93,116.44-71.88,41.3-25.48,82.61-50.95,123.94-76.39,4.97-3.06,10.18-5.67,15.69-7.67,8.68-3.14,17.41-3.24,26.26-.72,6.96,1.98,13.55,4.84,20.02,8.02,29.08,14.32,58.11,28.73,87.25,42.92,42.86,20.87,85.78,41.63,128.73,62.32,30.12,14.51,60.3,28.92,90.53,43.21,50.24,23.75,100.23,48.01,149.61,73.48,65.12,33.6,128.76,69.75,189.46,110.91,17.33,11.75,16.88,22.12,16.92,41.74.04,20.43.09,40.87.14,61.3v.04Z"
      style={{
        fill: "#58bfea",
      }}
    />
    <Path
      d="m714.15.47c3.94,1.62,8.22,1.11,12.31,1.65,12.97,1.7,25.58,4.72,37.92,8.99,4.25,1.47,8.03,3.85,11.97,5.92,23.69,12.43,47.39,24.83,71.08,37.27,48.59,25.51,97.16,51.02,145.74,76.54,32.79,17.22,65.57,34.46,98.36,51.69,40.99,21.53,81.98,43.05,122.96,64.59,28.97,15.23,57.92,30.49,86.86,45.78,2.88,1.52,5.85,2.84,8.87,4.05,16.58,6.66,32.01,15.18,45.2,27.25,17.57,16.09,27.77,36.31,32.76,59.34.93,4.3,2.3,8.59,2.12,13.14-1.87.54-3.06-.63-4.33-1.27-65.4-33.07-132.98-61.14-201.3-87.52-44.61-17.23-89.83-32.77-134.92-48.67-61.09-21.54-122.21-43.02-183.31-64.54-37.5-13.21-74.85-26.84-112.58-39.4-16.11-5.36-32.56-9.51-49.43-11.69-20.15-2.6-39.98-.77-59.59,4.41-18.77,4.96-36.79,12.05-54.92,18.85-38.68,14.49-77.33,29.05-115.99,43.59-44.92,16.89-89.83,33.79-134.74,50.68-41.55,15.62-83.1,31.22-124.65,46.85-12.67,4.77-25.34,9.49-37.32,15.94-23.12,12.45-35.87,32.13-40.91,57.38-2.58,12.97-3.7,26.09-4.16,39.28-.79,22.78-1.44,45.56-2.34,68.34-.83,21.23-2.31,42.45-1.75,63.72.2,7.73,1.47,15.34,3.5,22.79,4.09,15.04,13.01,26.62,25.73,35.43,7.21,4.99,14.78,9.36,22.61,13.26,57.12,28.41,114.2,56.89,171.42,85.11,43.52,21.47,87.16,42.69,130.85,63.82,43.38,20.98,86.65,42.2,129.59,64.07,17.57,8.95,35.02,18.15,52.55,27.17,5.34,2.75,10.93,4.9,16.58,6.96,14.21,5.18,28.24,4.35,42.19-.89,6.26-2.35,12.36-5.1,18.35-8.07,35.51-17.56,71.18-34.81,106.47-52.79,10.19-5.19,18.53-10.71,27.86-15.44,4.11-2.09,8.4-4.02,13.13-5.7,28.42-10.13,68.87-28.62,96.38-41.05,22.67-10.25,34.92-19.32,48.7-33.48,1.5-1.61,7.07-.08,9.11,1.25,2.87,1.87,5.93,3.45,8.85,5.23,9.49,5.76,13.88,14.42,13.97,25.32.13,15.78.12,31.56.14,47.34.03,23.5,0,46.99.05,70.49.01,5.51-.51,10.94-1.56,16.34-2.72,14.08-11.53,23.77-22.85,31.67-18.7,13.05-37.39,26.13-56.09,39.17-51.19,35.7-102.38,71.41-153.59,107.09-35.45,24.7-70.92,49.38-106.39,74.06-4.64,3.23-9.38,6.34-13.93,9.7-9.65,7.14-19.24,6.89-29.08.34-14.56-9.69-29.22-19.24-43.83-28.85-41.69-27.42-83.38-54.85-125.07-82.27-54.29-35.72-108.58-71.45-162.88-107.17-39.83-26.2-79.66-52.39-119.49-78.58-32.81-21.58-65.79-42.9-98.39-64.79-42-28.2-83.69-56.84-125.52-85.29-.71-.48-1.33-1.14-2.1-1.47-3.42-1.48-3.82-4.23-3.82-7.58.07-83.35-.03-166.7.14-250.06.03-16.43.56-32.89,2.85-49.22,4.06-28.98,14.41-54.92,36.42-75.22,10.3-9.5,22.01-16.89,34.5-23.1,6.91-3.43,13.93-6.64,20.85-10.05,37.52-18.52,75.02-37.08,112.54-55.61,57.66-28.48,115.32-56.95,172.98-85.42s115.32-56.95,172.98-85.42c23.68-11.69,47.33-23.45,71.06-35.02,15.69-7.65,32.41-11.89,49.64-14.41,4.84-.71,9.86-.16,14.49-2.29l24.14.48h.06Z"
      style={{
        fill: "#58bfea",
      }}
    />
    <G>
      <Path
        d="m625.58,555.73c-16.22-27.66-28.11-46.08-46.56-47.43-8.38-.61-16.16-1.18-23.43-1.82-1.16-.59-2.23-1.07-3.49-1.66,75.65,2.13,113.75-2,126.17-1.79,50.76,1.01,116.56,23.98,136.35,86.49-53.11-27.85-115.65-52.89-189.04-33.8h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m661.45,613.6c-15.07-21.46-26.25-41.33-35.88-57.78,73.4-19.19,135.94,5.85,189.04,33.8,2.04,6.37,3.55,13.09,4.53,20.29.92,6.58,2.16,12.99,3.61,19.21-39.05-18.6-107.79-30.06-161.3-15.53h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m691.08,651.17l-.55-.64c-11.11-12.65-20.62-25.07-28.97-37.02,53.5-14.53,122.14-2.98,161.3,15.53,5.81,24.69,15.76,46.28,27,63.94-38.8,1.27-122.75-2.37-158.77-41.81h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m901.19,742.16c-50.43-5.6-138.72-21.29-183.46-63.37-9.75-9.24-18.6-18.41-26.66-27.52,36.02,39.34,119.98,42.98,158.67,41.8,17.02,26.41,37.1,43.83,51.45,49.09h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m781.51,781.42c-98.87-45.14-91.09-130.8-91.09-130.8l.55.64c8.06,9.11,16.81,18.28,26.66,27.52,44.74,42.18,133.03,57.77,183.46,63.37,2.15.76,4.12,1.3,6,1.54-8.5,6.6-63.97,31.41-125.59,37.73h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m648.65,747.23c-5.61-57.56,12.9-133.61,12.9-133.61,8.35,11.94,17.87,24.37,28.97,37.02,0,0-7.78,85.66,91.09,130.8-46.88,4.79-97.17-1.2-132.96-34.2h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m648.65,747.23c-10.9-10.02-20.5-22.66-28.18-38.26-5.98-12.77-11.03-24.57-15.34-35.62.77-61.21,20.45-117.62,20.45-117.62,9.62,16.55,20.9,36.32,35.88,57.78,0,.1-18.51,76.15-12.8,133.72Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m605.13,673.35c-46.32-119.1-2-143.83-49.54-166.87,7.28.53,15.05,1.2,23.43,1.82,18.45,1.35,30.34,19.77,46.56,47.43,0,0-19.67,56.41-20.45,117.62Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
        }}
      />
      <Path
        d="m717.26,678.45c44.74,42.18,133.06,57.37,183.48,63.07-26.26-9.74-72.02-59.82-81.99-131.84-10.84-77.9-85.01-105.59-140.98-106.78-12.42-.21-50.52,3.92-126.17,1.79,1.26.59,2.43,1.08,3.49,1.66,7.28.53,15.05,1.2,23.43,1.82,40.11,2.74,49.16,85.82,138.73,170.29h0Z"
        style={{
          fill: "url(#uuid-573df821-4f9f-4d4a-a8cf-aa1cadb0b10b)",
          isolation: "isolate",
          opacity: 0.44,
        }}
      />
      <Path
        d="m906.04,743.12c-1.89-.24-3.85-.78-6-1.54-50.43-5.6-138.72-21.29-183.46-63.37-89.47-84.46-98.52-167.55-138.62-170.48-8.38-.61-16.16-1.18-23.43-1.82,52.01,25.07-5.74,52.32,64.89,202.38,65.91,133.67,269.73,47.83,286.62,34.83h0Z"
        style={{
          fill: "url(#uuid-b809095f-05b8-43c8-8ac0-2915d4457851)",
        }}
      />
      <Path
        d="m715.07,680.9c44.74,42.18,135.54,56.45,185.86,62.14,2.15.76,4.17.61,5.95.84,0,0,.1,0,.11-.09-1.89-.24-3.85-.78-6-1.54-50.43-5.6-138.69-21.69-183.43-63.77-89.58-84.37-98.63-167.45-138.72-170.39-8.38-.61-16.16-1.18-23.43-1.82,7.28.53,17.15,1.26,24.91,4.83,47.23,21.91,45.18,85.43,134.76,169.8h0Z"
        style={{
          fill: "url(#uuid-0f91d19b-0245-4e46-ad6a-1c007cb8aa00)",
        }}
      />
      <Path
        d="m555.41,506.17c30.79,14.89,23.03,30.56,26.4,72.12-1.26-41.7,7.47-58.21-26.4-72.12Z"
        style={{
          fill: "url(#uuid-4445a5df-eb30-4f3f-9d1a-68f323b59229)",
        }}
      />
      <Path
        d="m816.54,615.24c9.96,72.12,58.49,117.29,84.75,127.03-26.26-9.74-71.99-60.22-81.96-132.24-10.84-77.9-85.01-105.59-140.98-106.78-12.42-.21-50.52,3.92-126.17,1.79,75.65,2.13,111.06,3.22,123.47,3.53,55.87,1.08,130.15,28.68,140.88,106.68h0Z"
        style={{
          fill: "url(#uuid-b809095f-05b8-43c8-8ac0-2915d4457851)",
        }}
      />
      <Circle
        cx={822.36}
        cy={703.5}
        r={17.72}
        style={{
          fill: "url(#uuid-b809095f-05b8-43c8-8ac0-2915d4457851)",
        }}
      />
      <Circle
        cx={803.27}
        cy={663.84}
        r={17.72}
        style={{
          fill: "url(#uuid-b809095f-05b8-43c8-8ac0-2915d4457851)",
        }}
      />
    </G>
  </Svg>
)

export default SvgComponent
